import React, { useEffect } from "react";
import { useAsyncFn } from "react-use";
import { useLocation, useParams } from "react-router-dom";
import { useApi } from "../Api/ApiContext";
import { Col, Row, Spinner, Alert } from "reactstrap";
import { Main } from "../Layout";

const OrderConfirm = ({ removeOrderData }) => {
  removeOrderData();
  const { confirmOrder } = useApi();
  const [{ loading, error, value: confirmResponse }, confirm] = useAsyncFn(
    (ref, transactionId) => confirmOrder(ref, transactionId)
  );
  const { ref } = useParams();
  const location = useLocation();
  const transactionId = new URLSearchParams(location.search).get(
    "transaction_id"
  );

  useEffect(() => {
    if (ref) {
      confirm(ref, transactionId);
    }
  }, []);

  if (loading) {
    return (
      <Main>
        <Row>
          <Col lg={6} className="mx-auto">
            <Spinner color={"danger"} />
          </Col>
        </Row>
      </Main>
    );
  }

  if (error) {
    return (
      <Main>
        <Row className={"my-3 my-lg-3"}>
          <Col lg={6} className={"mx-auto"}>
            <Alert color="danger">
              <h1 className={"fs-5"}>Une erreur est survenue.</h1>
              <p>
                Si vous avez éffectué une commande, un mail vous sera envoyé
                pour confirmer la prise en compte de votre commande.
              </p>
            </Alert>
          </Col>
        </Row>
      </Main>
    );
  }

  return (
    <Main>
      {confirmResponse?.message === "success" && (
        <Row className={"my-3 my-sm-3"}>
          <Col lg={6} className="mx-auto">
            <Alert color="success">
              <h1 className={"fs-5"}>
                Félicitation ! votre commande a bien été enregistrée.
              </h1>
              <p>
                Vous recevrez un mail de confirmation dans l'adresse email que
                vous avez renseigné.
              </p>
            </Alert>
          </Col>
        </Row>
      )}
      {confirmResponse?.message === "failed" && (
        <Row className={"my-3 my-sm-3"}>
          <Col lg={6} className={"mx-auto"}>
            <Alert color={"danger"}>
              <h1 className={"fs-5"}>
                Echec du paiement ! votre commande sera annulée.
              </h1>
              <p>Vous ne serai pas débité du montant de la commande.</p>
            </Alert>
          </Col>
        </Row>
      )}
    </Main>
  );
};

export default OrderConfirm;
